var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    rx: 2,
    fill: "#3A92E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 7.75v3.5h3.5c.41 0 .75.34.75.75s-.34.75-.75.75h-3.5v3.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-3.5h-3.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.5v-3.5c0-.41.34-.75.75-.75s.75.34.75.75z",
    fill: "#fff"
  })));
}
export default SvgPlusSquare;